import { CourseRegistrationDTO } from "../interfaces/course-registration.interface";
import {
  PaypalOrderResponse,
  PaypalRegistrationResponse,
} from "../interfaces/paypal.interaface";
import http from "./axios";
import { handleError } from "./http-utils.service";

export const getClientID = async () => {
  try {
    const response = await http.get<{ success: boolean; clientID: string }>(
      `/paypal/clientID`,
      {
        headers: { "Content-type": "application/x-www-form-urlencoded" },
      },
    );
    if (response.data.success) {
      return response.data.clientID;
    }
  } catch (e) {
    throw handleError(e);
  }
};

export const getOrderID = async (data: CourseRegistrationDTO) => {
  const payload = {
    userId: data?.id,
    courseId: data?.course?.id,
    courseCostId: data?.course?.costId,
    licensePurchase: data.licensePurchase,
    waitList: false,
    paymentType: "Paypal",
  };
  try {
    const response = await http.post<PaypalOrderResponse>(
      `/paypal/orders`,
      payload,
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      },
    );
    return response.data;
  } catch (e) {
    throw handleError(`Could not initiate PayPal Checkout...${e}`);
  }
};

export const captureOrder = async (
  orderID: string,
  registrationData: CourseRegistrationDTO,
) => {
  try {
    let payload = {
      userId: registrationData?.id,
      courseId: registrationData?.course?.id,
      courseCostId: registrationData?.course?.costId,
      licensePurchase: registrationData.licensePurchase,
      waitList: false,
      paymentType: "Paypal",
    };

    const response = await http.post<PaypalRegistrationResponse>(
      `/paypal/orders/${orderID}/capture`,
      payload,
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      },
    );
    return response.data;
  } catch (e) {
    throw handleError(e);
  }
};
